import { useQuery } from "react-query";
import axios from "infra/http";
import { CollapsibleListCardHookFilter } from "ui/pages/Admin/Cadastros/UnidadePages/Detalhes/components/Dashboard/components/CollapsibleListCard";
import { PaginateResult } from "core/resources/types/shared";
import { CobrancaContaItem } from "../typings";

function useUnidadesContasPaginado(query: CollapsibleListCardHookFilter, enabled = true) {
  return useQuery(
    `/v1/unidades/${query.unidadeId}/contas-${query.limit}-${query.page}-${query.search}`,
    async () => {
      const res = await axios.get<PaginateResult<CobrancaContaItem>>(
        `/v1/unidades/${query.unidadeId}/contas`,
        {
          params: {
            ...query,
          },
        }
      );

      return res.data;
    },
    {
      enabled: !!query.unidadeId && enabled,
    }
  );
}

export default useUnidadesContasPaginado;
